var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('div',{staticClass:"info"},[_vm._v("Super AI digital human incubation platform, full hosting operation lets you have no worries ")]),_c('div',{staticClass:"button"},[_vm._v(" Contact us ")])])
}]

export { render, staticRenderFns }